import {
    CREATE_HSN_MASTER_FAILURE,
    CREATE_HSN_MASTER_REQUEST,
    CREATE_HSN_MASTER_SUCCESS,
    CREATE_USER_FORM_HSN_MASTER,
    FETCH_HSN_MASTER_FAILURE,
    FETCH_HSN_MASTER_REQUEST,
    FETCH_HSN_MASTER_SUCCESS,
    FETCH_SINGLE_HSN_MASTER_FAILURE,
    FETCH_SINGLE_HSN_MASTER_REQUEST,
    FETCH_SINGLE_HSN_MASTER_SUCCESS,
    HSN_MASTER_USERFORM_RESET,
    UPDATE_HSN_MASTER_REQUEST,
    UPDATE_HSN_MASTER_SUCCESS,
    UPDATE_HSN_MASTER_FAILURE,
    DELETE_HSN_MASTER_REQUEST,
    DELETE_HSN_MASTER_SUCCESS,
    DELETE_HSN_MASTER_FAILURE,
    FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS,
    FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST,
    FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE,
    GENERAL_HSN_MODAL_OPEN
} from './hsnMaster.actionsType';

export const HSN_MASTER = 'hsnMaster';

let initialState = {
    loading: false,
    hsnMaster: [],
    userform: {},
    hsnList: [],
    selectedHsn: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let hsnMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_HSN_MASTER_REQUEST:
        case FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST:
        case CREATE_HSN_MASTER_REQUEST:
        case FETCH_SINGLE_HSN_MASTER_REQUEST:
        case UPDATE_HSN_MASTER_REQUEST:
        case DELETE_HSN_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_HSN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                hsnMaster: updatePayload
            };
        case CREATE_HSN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_HSN_MASTER_SUCCESS:
            return {
                ...state,
                selectedHsn: updatePayload,
                loading: false,
                userform: {
                    hsnCategory: updatePayload.fldFKCategory,
                    salesCode: updatePayload.fldSalesCode,
                    SalesPer: updatePayload.fldSalesPct,
                    jobWorkCode: updatePayload.fldJobworkCode,
                    jobWorkPer: updatePayload.fldJobworkPct
                }
            };
        case GENERAL_HSN_MODAL_OPEN:
            return {
                ...state,
                loading: false,
                HsnModal: payload
            }
        case UPDATE_HSN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedHsn: {}
            };
        case DELETE_HSN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedHsn: {},
                hsnList: []
            };
        case FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                hsnList: updatePayload
            };
        case FETCH_HSN_MASTER_FAILURE:
        case CREATE_HSN_MASTER_FAILURE:
        case FETCH_SINGLE_HSN_MASTER_FAILURE:
        case UPDATE_HSN_MASTER_FAILURE:
        case DELETE_HSN_MASTER_FAILURE:
        case FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_HSN_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case HSN_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                selectedHsn: {},
                hsnList: []
            };
        default:
            return state;
    }
};
